import styled from 'styled-components'
import { getAllVerticals } from 'src/utils/contentful'
import Layout from 'src/components/Layout'
import CareersAgentHero from 'src/components/Careers/CareersAgentsHero'
import CareersKeyPoints from 'src/components/Careers/CareersKeyPoints'
import CareersInsurersParade from 'src/components/Careers/CareersInsurersParade'
import CareerOpenings from 'src/components/Careers/CareerOpenings'

const tempValuePoints = [
  {
    title: 'Help Prequalified Shoppers',
    description:
      'PolicyScout prequalifies each caller, so you know they’re interested and ready to talk.',
  },
  {
    title: 'Log In & Enjoy Free, Inbound Calls',
    description:
      'Our marketing teams are working hard to bring quality calls your way. These calls are free to you as an agent.',
  },
  {
    title: 'More Licenses, More Calls',
    description:
      'Log in, get calls. It’s that easy! Once you’re in our platform, we send you calls from those in your licensed states. The more state licenses you have, the more calls we provide.',
  },
  {
    title: 'The Platform That Works For You',
    description:
      'The PolicyScout platform does it all. We dial and receive calls, track your success, give you scripts and even handle your compensation. No more managing several platforms at once.',
  },
  {
    title: 'Refer Your Friends. Earn Bonuses',
    description:
      'Invite your friends to join you on the platform, and we’ll give you both $100 after they make their first call!',
  },
  {
    title: 'PolicyScout Is Above The Rest',
    description:
      'PolicyScout is unlike any other insurance sales opportunity. See how it compares.',
  },
]

const tempOpenings = [
  {
    title: 'Life Insurance Agent',
    location: 'Salt Lake City, UT',
    remote: true,
  },
  {
    title: 'Health Insurance Agent',
    location: 'Salt Lake City, UT',
    remote: true,
  },
  {
    title: 'Medicare Insurance Agent',
    location: 'Salt Lake City, UT',
    remote: true,
  },
  {
    title: 'Auto Insurance Agent',
    location: 'Salt Lake City, UT',
    remote: true,
  },
]

export default function CareerAgents({ slug, image, title, description, verticals }) {
  return (
    <Layout verticals={verticals} footer={{ noBorder: true }}>
      <main>
        <CareersAgentHero
          verticalSlug={slug}
          hero={{ photo: { url: image } }}
          title={title}
          subTitle={
            'We’re always looking to climb higher, expanding our reach and developing innovative ways to connect people to policies they love, and we’d love for you to come along with us.'
          }
        />
        <CareersKeyPoints dataPoints={tempValuePoints} header={'Why PolicyScout?'} />
        <CareersInsurersParade vertical={slug} />
        <CareerOpenings openings={tempOpenings} />
      </main>
    </Layout>
  )
}

export async function getStaticProps() {
  const slug = 'careers'
  const image = '/images/agents-hero.jpeg'
  const title = 'Agents'
  const description = ''

  const verticals = await getAllVerticals()

  return { props: { slug, image, title, description, verticals } }
}
